import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const { Form, OverlayTrigger, Tooltip } = require('react-bootstrap');

export const TYPE_TOOLTIP_FORM_LABEL = {
  QUESTION_CIRCLE: 'fa-question-circle',
};

const TooltipLabel = React.memo(
  ({ text, type, id, customeContent, className, placement }) => {
    return (
      <OverlayTrigger
        placement={placement}
        delayShow={500}
        overlay={
          <Tooltip html={true} id={id || Math.random()}>
            {customeContent ? customeContent : text}
          </Tooltip>
        }
      >
        <i
          className={clsx(
            'fa mr-l-5',
            className && className,
            TYPE_TOOLTIP_FORM_LABEL[type] ??
              TYPE_TOOLTIP_FORM_LABEL.QUESTION_CIRCLE
          )}
        />
      </OverlayTrigger>
    );
  }
);

TooltipLabel.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['info', 'warning', 'error']),
  id: PropTypes.string,
  customeContent: PropTypes.node,
  className: PropTypes.string,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
};

TooltipLabel.defaultProps = {
  type: 'info',
  placement: 'top',
  className: '',
};

const FormTitleCC = React.memo(({ title, toolTip, isRequired }) => {
  const { text, ...restTooltipProps } = toolTip || {};
  if (!title) return null;
  return (
    <Form.Label>
      {title}
      {isRequired && <span className="require">*</span>}
      {(text || restTooltipProps.customeContent) && <TooltipLabel text={text} {...restTooltipProps} />}
    </Form.Label>
  );
});

FormTitleCC.propTypes = {
  title: PropTypes.string.isRequired,
  toolTip: PropTypes.object,
  isRequired: PropTypes.bool,
};

export default FormTitleCC;
